"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockLocaleServiceInitParamsUtil = void 0;
const localeConfig = {
    defaultUserLanguageTag: 'en',
    availableArticleLanguageTags: ['de-DE', 'en-GB', 'en-US', 'es-ES'],
    defaultArticleLanguageTags: ['en-GB', 'en-US'],
    defaultCadClickLanguageTag: 'en-GB',
    missingTranslationValue: 'n/a',
};
class MockLocaleServiceInitParamsUtil {
    static getMockLocaleServiceInitParamsUsWithISales() {
        return {
            localeConfig,
            iSalesCountry: 'US',
            iSalesLanguageTag: 'en-US',
            iSalesCurrency: 'USD',
            userLanguageTag: 'en-US',
            userCountry: 'US',
            shopCountry: 'US',
            shopLanguageSubtag: 'us',
            igusDomain: 'www.igus.com',
        };
    }
    static getMockLocaleServiceInitParamsDeWithISales() {
        return {
            localeConfig,
            iSalesCountry: 'DE',
            iSalesLanguageTag: 'de-DE',
            iSalesCurrency: 'EUR',
            userLanguageTag: 'de-DE',
            userCountry: 'DE',
            shopCountry: 'DE',
            shopLanguageSubtag: 'de',
            igusDomain: 'www.igus.de',
        };
    }
    static getMockLocaleServiceInitParamsGbWithISales() {
        return {
            localeConfig,
            iSalesCountry: 'GB',
            iSalesLanguageTag: 'en-GB',
            iSalesCurrency: 'GBP',
            userLanguageTag: 'en-GB',
            userCountry: 'GB',
            shopCountry: 'GB',
            shopLanguageSubtag: 'en',
            igusDomain: 'www.igus.co.uk',
        };
    }
    static getMockLocaleServiceInitParamsChWithISales() {
        return {
            localeConfig,
            iSalesCountry: 'CH',
            iSalesLanguageTag: 'de-CH',
            iSalesCurrency: 'CHF',
            userLanguageTag: 'de-CH',
            userCountry: 'CH',
            shopCountry: 'CH',
            shopLanguageSubtag: 'de',
            igusDomain: 'www.igus.ch',
        };
    }
    static getMockLocaleServiceInitParamsDeWithoutISales() {
        return {
            localeConfig,
            shopCountry: 'DE',
            shopLanguageSubtag: 'de',
            userLanguageTag: 'de-DE',
            userCountry: 'DE',
            igusDomain: 'www.igus.de',
        };
    }
    static getMockLocaleServiceInitParamsUsWithoutISales() {
        return {
            localeConfig,
            shopCountry: 'US',
            shopLanguageSubtag: 'en',
            userLanguageTag: 'en-US',
            userCountry: 'US',
            igusDomain: 'www.igus.com',
        };
    }
}
exports.MockLocaleServiceInitParamsUtil = MockLocaleServiceInitParamsUtil;
//# sourceMappingURL=MockLocaleServiceInitParamsUtil.js.map